import type { OutfitSlot } from '../types';

// 스타터 — 클래식 검정 롱 스트레이트
export const STARTER_OUTFIT_IDS: string[] = ['hair_classic_long_straight_black'];

export const STARTER_EQUIPPED: Partial<Record<OutfitSlot, string>> = {
  hair: 'hair_classic_long_straight_black',
};

export const STARTER_PET_ID = 'pet_dog_brown';
